<template>
    <div class="main">
        <!-- <h1>Employee Portal Home</h1> -->
        <div class="adminOnly menu" v-if="user != undefined && user.admin"> 
          <h2>Admin</h2>
          <ul><li>
            <router-link to="/admin">Reporting</router-link>
          </li></ul>
          <div class="divider"></div>
        </div>
        <div class="employeeOnly menu">
          <h2>Employee</h2>
            <ul>
              <li><router-link to="/1">Weekly Time Confirmation</router-link></li>
              <li><router-link to="/2">Meal Break Waiver Agreement</router-link></li>
            </ul>
      </div>
    </div>
  </template>
  
<script>
  import Cookies from 'js-cookie'

  export default {
    name: 'MainView',
    props: {
      msg: String
    },
    data() {
      return {
        cadence: [],
        user: null,
        formID: this.$route.params.id,
        surveyCadenceIndex: -1,
        // questions:null,
        answers:null
      }
    },
      components: {
    },
    methods: {
 
      getSiteCookie(name) {
        const value = Cookies.get(name);
        return value
      },
      formateDate(timestamp) {
        let dateObj = new Date(timestamp)
        return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`
      },
    },
    mounted() {
        console.log('mounted')
        console.log(process.env, 'envionment varsxxx')
        let token = this.getSiteCookie('btoken')
        this.user = JSON.parse(localStorage.getItem(token))
        // if(process.env == 'development') {
        //     this.user.admin = true
        // }
    }
  }
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only --> 
  <style scoped lang="scss">
  /* h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: black;
    font-weight:normal;
  } */


  .main{
    text-transform: uppercase;
    display:block;
    position:relative;
    .logout {
      text-align: right;
      display: block;
      span{
        display:inline-block;

      }
      .link {
        cursor: pointer;
        padding-left:4px;
        display:inline-block;
        text-decoration:underline;
        /* position:absolute;
        right:0;
        top:0; */
        
      }
    }
    .divider{
      height:1px;
      border-bottom:1px solid #ebebeb;
      width:80%;
      display:block;
      margin: 0 auto;
    }
    .menu{
      /* border: 2px solid #ebebeb; */
      display: block;
      width: auto;
      margin: 20px auto;
      padding: 10px 30px;
      box-sizing: border-box;
      border-left: 0;
      border-right: 0;
      border-bottom: 0;
      h2 {
          font-weight: bold;
      }
      ul{
          list-style: none;
          padding:5px 0;
          text-align: center;
          line-height:3;
      }
    }
    /* .calendar {
      position:relative;
      text-align:left;
      h1{
        text-align: center;;
      }
      .previousWeeks {
        display:block;
      }
      position: relative;
      text-align: left;
      padding: 15px;
   
      border-collapse: collapse;
      table{
        width:100%;
        border-spacing:0;
        th {
          border-bottom:1px solid #ccc;
        }
        th, td {

          color:black;
          padding:10px 5px;
        }
        td {
          border-bottom:1px solid #ebebeb;
        }
      }
      button.backToMainBtn{
        position:relative;
        right:10px; 
        top: 10px;
      }
      .survey {
        text-align:justify;
        padding:20px 50px;
        box-sizing: border-box;
        margin:0 auto;
        max-width:800px;
        border:1px solid #ebebeb;
        position:relative;
        box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);
        background-color:#a5a32a1f;
        .dateLabel {
          font-weight: bold;
          text-align: center;
          display: block;
          padding: 20px 0;
        }
        .header {
          padding:5px 0;
          display:block;
        }

        .form {
          .question {
            text-align: left;
            display:list-item;
            list-style-type: decimal;
            padding:0 0 15px 0;
            padding-left:30px;
            margin-left:15px;

            .questionHeader{
              display:block;
            }

            .questionAnswer {
              display: inline-block;
              padding: 10px;
              margin: 0;
              .selection {
                display:inline-block;
                vertical-align: middle;
                padding-right:10px;
                span{
                  display:inline-block;
                  vertical-align: middle;;
                }
                input {
                  display: inline-block;
                  vertical-align: middle;
                  margin: 0 10px 0 3px;
                }
              }
              

            }
            .subquestions{
              display:block;
              .subquestion{
                padding-top:20px;
                span{
                  display:inline-block;
                }
                input{
                  display:block;
                  width:500px;
                  max-width: 80%;
                }
              }
            }
          }
        }
      }
    } */
  }
  </style>
  